module.exports = __webpack_public_path__ + "img/cutting-edge-en-1.a270640.jpg";